import { Button } from "@mui/material";
import { useContext, useState } from "react";
import CreateCompetitorModal from "../../../components/Modal/CreateCompetitor/CreateCompetitorModal";
import CompetitorsTable from "../../../components/Tables/CompetitorsTable/CompetitorsTable";
import { Context } from "../../../context/context";

export default function Competitors() {
  const { sidebar } = useContext(Context);
  const [open, setOpen] = useState(false);

  return (
    <>
      <main className={sidebar ? "container" : "container-full"}>
        <Button
          size="medium"
          style={{ width: "350px" }}
          variant="contained"
          onClick={() => setOpen(true)}
          className="new-user"
        >
          Cadastrar novo concorrente
        </Button>

        { open && <CreateCompetitorModal setOpen={setOpen} open={open} />}

        <div className="table-container">
          <CompetitorsTable />
        </div>
      </main>
    </>
  );
}
